import GameBootstrap from './bootstrap/GameBootstrap'

const App = () => {
  return (
    <div className="app-outer-container">
      <div className="app-inner-container">
        <GameBootstrap />
      </div>
    </div>
  )
}

export default App
